import { render, staticRenderFns } from "./InviteNewMember.vue?vue&type=template&id=2abdb08a&scoped=true&"
import script from "./InviteNewMember.vue?vue&type=script&lang=js&"
export * from "./InviteNewMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abdb08a",
  null
  
)

export default component.exports